import * as signalR from "@microsoft/signalr";
import moment from "moment";
import "moment-timezone";

export default class Constants {
    public static readonly ClientTickLength: number = 1000; // 1 second
    public static readonly ClientTimerOffsetBuffer: number = 2000; // 2 seconds
    public static readonly CurrencyShortFormat = "$0[,0]";
    public static readonly UnscheduledTime: string = "0001-01-01T00:00:00Z";
    public static readonly DateFormat: string = "MMMM D, YYYY [at] h:mma zz";
    public static readonly DateFormatAuctionHeader: string =
        "dddd, MMMM D, YYYY [at] h:mma zz";
    public static readonly DateFormatAudit: string = "MMM D, YYYY h:mma zz";
    public static readonly DateFormatBidLog: string = "MMM D, YYYY h:mm:ssa zz";
    public static readonly AuctionDateTop: string = "MMMM D, YYYY";
    public static readonly AuctionDateBottom: string = "h:mma zz";
    public static readonly DefaultBidIncrement: number = 10000; // $10,000
    public static readonly DefaultHoursAfterStartTime: number = 2;
    public static readonly EmailRegExp: RegExp =
        /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i;
    public static readonly EnBlocDurationMinutes: number = 15;
    public static readonly EnBlocStartWindowMinutes: number = 15;
    public static readonly IsIE: boolean =
        navigator.userAgent.indexOf("MSIE ") > -1 ||
        navigator.userAgent.indexOf("Trident/") > -1;
    public static readonly NodeEnvironmentDev = "development";
    public static readonly ScrollAnimationLength = 800; // 0.8 seconds
    public static readonly ShortDateFormat: string = "MMMM D, YYYY";
    public static readonly SignalrLogLevel = signalR.LogLevel.Error;
    public static readonly SignalrLogLevelDev = signalR.LogLevel.Debug;
    public static readonly TimeFormat: string = "h:mma zz";
    public static readonly TypeDateFormat: string = "YYYY-MM-DD HH:mm";
    public static readonly TimeFormatAmPmOnly: string = "a";
    public static readonly TimeFormatNoZoneNoAmPm: string = "h:mm";
    public static readonly TimeZone: string = moment.tz.guess();
    public static readonly UrlCreateAuction = "create";
    public static readonly UrlCreateUser = "create";
    public static readonly ViewDeploys = "view-deploys";
    public static readonly ViewReminders = "view-reminders";

    /** Defines the currency used when generating Stripe credit card tokens.  */
    public static readonly StripeTokenCurrencyCAD = "CAD";

    public static readonly Routes = {
        AdminAuctionDetail: (url?: string) =>
            `/admin/auctions/${url || ":url"}`,
        AdminAuctionList: () => "/admin/auctions",
        AdminUserDetail: (email?: string) =>
            `/admin/users/${email || ":email"}`,
        AdminUserList: () => "/admin/users",
        AuctionDetail: (url: string, config: { baseUrl: string }) =>
            new URL(`/auctions/${url}`, config.baseUrl || "https://clhbid.com"),
        AuctionList: (config: { baseUrl: string }) =>
            new URL("/auctions", config.baseUrl || "https://clhbid.com"),
        ParcelDetails: (
            auctionUrl: string,
            parcelUrl: string,
            config: { baseUrl: string }
        ) =>
            new URL(
                `/auctions/${auctionUrl}/parcels/${parcelUrl}`,
                config.baseUrl || "https://clhbid.com"
            ),
        ForgotPassword: () => "/forgotpassword",
        Home: () => "https://www.clhbid.com/",
        Login: () => "/login",
        Logout: () => "/logout",
        Parcels: (url?: string) => `/auctions/${url || ":url"}/parcels`,
        PasswordReset: (token?: string) =>
            `/passwordreset/${token || ":token"}`,
        Profile: () => "/profile",
        Register: () => "/register",
        TermsAndConditions: (config: { baseUrl: string }) =>
            new URL(
                "/terms-and-conditions",
                config.baseUrl || "https://clhbid.com"
            )
    };

    public static CurrentDate = () => new Date();
    public static SetDocumentTitle(title: string) {
        document.title = `${title} | CLHBid`;
    }

    public static readonly GAEvents = {
        SignUp: "sign_up",
        Login: "login",
        Form: {
            Submit: "form_submit",
            Invalid: "form_invalid_submission"
        }
    };

    public static readonly StackAdaptEvents = {
        PlaceBid: "PlaceBid",
        PlaceHighestBid: "PlaceHighestBid"
    };
}
